<template>
    <div id="budget_issues" class="container-fluid">
        <router-link class="btn btn-secondary main-button ml-2 pull-right" :to="{ path: '/budget/issues/unclassified/campaigns'}" style="pointer-events:initial !important;">Unclassified Campaigns</router-link>
        <router-link class="btn btn-secondary main-button ml-2 pull-right" :to="{ path: '/budget/issues/missing/clients'}" style="pointer-events:initial !important;">Missing Clients</router-link>
        <button class="btn btn-secondary main-button reverse unclickable pull-right" style="pointer-events:initial !important;">Excluded Classifications</button>
        <h5 class="text-center my-3">Excluded Classifications</h5>
        <v-client-table :data="tableData" :columns="columns" :options="options"></v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                tableData: [],
                columns: ['account_id', 'account_name', 'campaign_id', 'campaign_name', 'campaign_classification'],
                options: {
                    headings: {
                        account_id: 'Account ID',
                        account_name: 'Account Name',
                        campaign_id: 'Campaign ID',
                        campaign_name: 'Campaign Name',
                        campaign_classification: 'Campaign Classification'
                    },
                    sortable: ['account_id', 'account_name', 'campaign_id', 'campaign_name', 'campaign_classification'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} excluded classifications|{count} excluded classifications|One excluded classification',
                        filter: '',
                        filterPlaceholder: 'Search ...',
                        noResults: 'No matching excluded classifications'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/budget/issues/excluded/classifications')
                ])
                .then(axios.spread((issues) => {
                    this.tableData = issues.data;
                }));
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
